import { UserDetails } from 'app/profile/models/user.model';
import { Profile, SupplierWarehouse, Location, NavigationList } from 'app/profile/models/profile.model';
import { SupplierPropertyValue, TabPermissions, Permission, FieldConfig, SupplierAddressPropertyValues, Contract } from 'app/profile/models/supplier.model';
import { ValidationTask } from 'app/profile/models/people.model';
import { FormTemplate } from 'app/profile/models/onboarding.model';
import { SupplierCommunicationValidation } from 'app/profile/models/generic.model';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';

export class SupplierState {
    supplier: SupplierPropertyValue;
    warehouseAddresses: SupplierAddressPropertyValues[];
    currentUser: UserDetails;
    tabPermission: TabPermissions;
    supplierProfile: Profile
    FieldConfiguration: FieldConfig[];
    pickupWarehouseAddresses: SupplierAddressPropertyValues[];
    externalPartnerAddress: SupplierAddressPropertyValues[];
    validationTask: ValidationTask;
    contracts: Contract[];
    locations: Location[];
    navigationList: NavigationList[];
    manufacturingAddresses: SupplierAddressPropertyValues[];
    formTemplate: FormTemplate;
    otpRequest: SupplierCommunicationValidation;
    userPendingTasks: SupplierTaskDetail[];
    preventativeInProgress: boolean;
}

export const intitialState: SupplierState = {
    supplier: new SupplierPropertyValue(),
    currentUser: null,
    tabPermission: {
        details: Permission.NoAccess,
        address: Permission.NoAccess,
        contact: Permission.NoAccess,
        bank: Permission.NoAccess,
        tax: Permission.NoAccess,
        document: Permission.NoAccess,
        entity: Permission.NoAccess,
        status: Permission.NoAccess
    },
    supplierProfile: null,
    FieldConfiguration: null,
    warehouseAddresses: null,
    pickupWarehouseAddresses: null,
    externalPartnerAddress: null,
    validationTask: null,
    contracts: null,
    locations: null,
    navigationList: null,
    manufacturingAddresses: null,
    formTemplate: new FormTemplate(),
    otpRequest: null,
    userPendingTasks: null,
    preventativeInProgress: null
}
